import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';
import { RelatedJobBus } from './RelatedJobBus';
import { ConstructionChartDetail } from './ConstructionChartDetail';
import { InvoiceDrawBus } from './InvoiceDrawBus';
import { DispatchNoteBus } from './DispatchNoteBus';

export class CnstJobBus extends BaseBus
{
  CID(): any {
    return this.dispatchId;
  }
    constructor(data: CnstJobBus) {
        super(data);
    //Object.assign(this, data);
    //try {
    //  this.receivedDateTime = CommonFunctions.getDate(data.receivedDateTime);
    //  this.insertDt = CommonFunctions.getDate(data.insertDt);
    //  this.updateDt = CommonFunctions.getDate(data.updateDt);
    //  this.estimatedBeginDate = CommonFunctions.getDate(data.estimatedBeginDate);
    //  this.estimatedEndDate = CommonFunctions.getDate(data.estimatedEndDate);

    //  this.jobWarrantyEndDate = CommonFunctions.getDate(data.jobWarrantyEndDate);
    //  this.refTrackNbrDt = CommonFunctions.getDate(data.refTrackNbrDt);
    //  this.finalBillingDt = CommonFunctions.getDate(data.finalBillingDt);
    //  this.sageDt = CommonFunctions.getDate(data.sageDt);
    //}
    //catch {

    //}
  }
    initialize(data: CnstJobBus) {
    super.initialize(data);
    try {
      this.receivedDateTime = DateFunctions.getDate(data.receivedDateTime);
        this.insertDt = DateFunctions.getDate(data.insertDt);
        this.updateDt = DateFunctions.getDate(data.updateDt);
        this.estimatedBeginDate = DateFunctions.getDate(data.estimatedBeginDate);
        this.estimatedEndDate = DateFunctions.getDate(data.estimatedEndDate);

        this.jobWarrantyEndDate = DateFunctions.getDate(data.jobWarrantyEndDate);
        this.finalBillingDt = DateFunctions.getDate(data.finalBillingDt);
        this.sageDt = DateFunctions.getDate(data.sageDt);
    }
    catch {

    }

    }
    get inFinance(): boolean {
        return CommonFunctions.hasGuidValue(this.sageDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.receivedDateTime = DateFunctions.getDateNow();
        this.receivedById = personId;
        this.dispatchStatusId = CommonValues.Dispatch_ReadyForDispatch;
        this.priorityId = CommonValues.Priority_Normal;
        this.isConstruction = true;
    }
    setFromForm(data: CnstJobBus) {
    super.setFromForm(data);
    let dateNow = CommonFunctions.getDateNow();
    if (this.hasId) {
      this.updateDt = dateNow;
      this.insertDt = data.insertDt;
      this.insertUserId = data.insertUserId;
    }
    else {
      this.insertDt = dateNow;
      this.insertUserId = data.insertUserId;
    }
    
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateDt = date;
            this.updateUserid = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.updateDt = date;
            this.updateUserid = userId;
        }
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
        }
    }
    setBeforeSave() {
        this.receivedDateTime = DateFunctions.getDateTimeWithUTCOffset(this.receivedDateTime);
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        if (DateFunctions.isValidDate(this.estimatedBeginDate)) {
            this.estimatedBeginDate = DateFunctions.getDateWithUTCOffset(this.estimatedBeginDate);
        }
        if (DateFunctions.isValidDate(this.estimatedEndDate)) {
            this.estimatedEndDate = DateFunctions.getDateWithUTCOffset(this.estimatedEndDate);
        }
        if (DateFunctions.isValidDate(this.jobWarrantyEndDate)) {
            this.jobWarrantyEndDate = DateFunctions.getDateWithUTCOffset(this.jobWarrantyEndDate);
        }
        if (DateFunctions.isValidDate(this.refTrackNbrDt)) {
            this.refTrackNbrDt = DateFunctions.getDateWithUTCOffset(this.refTrackNbrDt);
        }
        if (DateFunctions.isValidDate(this.finalBillingDt)) {
            this.finalBillingDt = DateFunctions.getDateWithUTCOffset(this.finalBillingDt);
        }
        if (DateFunctions.isValidDate(this.sageDt)) {
            this.sageDt = DateFunctions.getDateWithUTCOffset(this.sageDt);
        }
        if (DateFunctions.isValidDate(this.refreshDate)) {
            this.refreshDate = DateFunctions.getDateTimeWithUTCOffset(this.refreshDate);
        }
    }
closeOutResources: boolean = false;
closeOutResourcesStatusId: any;

dispatchId: any;
customerId: any;
locationId: any;
companyId: any;
priorityId: any;
dispatchStatusId: any;
receivedById: any;
quoteId: any;
invoiceId: any;
receivedDateTime: Date;
needsQuote: boolean;
notToExceed: number;
dispatchNumber: string;
ponumber: string;
whoCalledName: string;
dispatchReason: string;
insertUserId: any;
insertDt: Date;
updateUserid: any;
updateDt: Date;
wonumber: string;
accountClassId: any;
callbackId: any;
isProgressBill: boolean;
estimatedBeginDate: Date;
estimatedEndDate: Date;
isConstruction: boolean;
contractPrice: number;
pooverrideUserId: any;
estimatedCost: number;
relatedJobTypeId: any;
jobWarrantyEndDate: Date;
masterJobId: any;
foremanId: any;
refTrackNbr: string;
refTrackNbrDt: Date;
refTrackNbrUserId: any;
minimumSkill: number;
pmprice: number;
labTaxRate: number;
matTaxRate: number;
otherTaxRate: number;
isRetailTax: boolean;
stockReplenishWh: any;
finalBillingDt: Date;
jobClassificationId: any;
contractAdminId: any;
contractProjAdminId: any;
wipcomplete: boolean;
contractProjEstId: any;
certPayrollRequired: boolean;
drawDateInfo: string;
changeOrderInfo: string;
sageDt: Date;
autoCreateId: string;
dispatchRepairCatId: any;
contractDivisionId: any;
contractJrProjAdminId: any;
dispatchActionCodesId: any;
dispatchCauseCodesId: any;
dispatchFailureCodesId: any;
dispatchProblemCodeId: any;
refreshDate: Date;
dispatchStatusName: string;
customerName: string;
locationName: string;
color: number;
priorityName: string;
receivedByLastName: string;
quoteNumber: string;
quickSearchKey: string;
invoiceNumber: string;
assignedDate: Date;
startDate: Date;
addressLine1: string;
addressLine2: string;
city: string;
stateProvince: string;
postalCode: string;
enableProgressBill: boolean;
lastStatusDate: Date;
relatedJobType: string;
stockReplenishWH: any;
acctMgr: string;
underConstruction: boolean;
co: number;
billingPersonId: any;
hasOpenConstContracts: boolean;
timeMat: boolean;
timeMatPercent: number;
setJobBackToService: boolean;
 //dispatchId: any;
 //customerId: any;
 //locationId: any;
 //dispatchStatusId: any;
 //dispatchNumber: string;
 //poNumber: string;
 //woNumber: string;
 //priorityId: any;
 //receivedById: any;
 //receivedDateTime: Date;
 //notToExceed: number;
 //contractPrice: number;
 //whoCalledName: string;
 //needsQuote: boolean;
 //dispatchStatusName: string;
 //customerName: string;
 //locationName: string;
 //color: number;
 //priorityName: string;
 //receivedByLastName: string;
 //dispatchReason: string;
 //quoteId: any;
 //quoteNumber: string;
 //quickSearchKey: string;
 //invoiceId: any;
 //invoiceNumber: string;
 //assignedDate: number;
 //startDate: number;
 //addressLine1: string;
 //addressLine2: string;
 //city: string;
 //stateProvince: string;
 //postalCode: string;
 //accountClassId: any;
 //callbackId: any;
 //isProgressBill: boolean;
 //estimatedBeginDate: Date;
 //estimatedEndDate: Date;
 //enableProgressBill: boolean;
 //lastStatusDate: Date;
 //isConstruction: boolean;
 //poOverrideUserId: any;
 //estimatedCost: number;
 //relatedJobTypeId: any;
 //jobWarrantyEndDate: Date;
 //masterJobId: any;
 //relatedJobType: string;
 //foremanId: any;
 //refTrackNbr: string;
 //minimumSkill: number;
 //pmPrice: number;
 //stockReplenishWH: any;
 //acctMgr: string;
 //contractAdminId: any;
 //contractProjAdminId: any;
 //jobClassificationId: any;
 //finalBillingDt: Date;
 //contractProjEstId: any;
 //underConstruction: boolean;
 //certPayrollRequired: boolean;
 //drawDateInfo: string;
 //sageDt: Date;
 //co: string;
 //autoCreateId: string;
 //dispatchRepairCatId: any;
 //billingPersonId: any;
 //hasOpenConstContracts: boolean;
 //contractDivisionId: any;
 //insertUserId: any;
 //insertDt: Date;
 //updateUserid: any;
 //updateDt: Date;
}
